// extracted by mini-css-extract-plugin
export default {"date":"style_date__61WUP","icon":"style_icon__hg1S8","returnType":"style_returnType__gsI+h","space":"style_space__+J2HR"};